module.exports = __webpack_public_path__ + "img/arrow.6ef4b69c.svg";